import { Component, Input } from '@angular/core';
import { ProfessionalRolBaseComponent } from '../user-roles/user-roles.base.component';

@Component({
  selector: 'app-role-med-staff',
  templateUrl: './role-med-staff.component.html',
  styleUrls: ['./role-med-staff.component.scss'],
})
export class RoleMedStaffComponent extends ProfessionalRolBaseComponent {
  @Input({ required: true }) public education: string;
}
